import { post } from './glosbe-dictionary-api-helper';
export function addExample(data) {
    return post({
        endpoint: 'add/example',
        data, options: { credentials: 'include' }
    });
}
